import { useEffect as n } from "react";
import { usePopover as s } from "../../Popover/hooks/usePopover.js";
const c = ({
  id: o,
  layout: e = "stack",
  multiSelect: a,
  role: r
}) => {
  const t = s(), i = e === "stack" ? "vertical" : "horizontal";
  return n(() => (t != null && t.toggleAriaControls && o && t.toggleAriaControls(o, !0), () => {
    t != null && t.toggleAriaControls && o && t.toggleAriaControls(o, !1);
  }), [o, t]), {
    "aria-multiselectable": r === "listbox" && a === !0 ? !0 : void 0,
    "aria-orientation": r === "menu" ? i : void 0
  };
};
export {
  c as useMenuAria
};
